/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';

class ComplaintsService {
  async addComplaint(state, body) {
    const response = await api.post('/complaints/add', {}, body);
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new ComplaintsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/complaints/services/ComplaintsService/ComplaintsService.js